
import { OtcInput } from '../CommonComponents'
export default {
    name: "the-identifier",
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: false,
            default: ''
        },
        layout: {
            type: String,
            required: false,
            default: 'chain'
        },
        error: {
            required: false,
            default: '',
            type: String
        },
        showResendText: {
            required: false,
            default: false,
            type: Boolean
        },
        showJunkMailText: {
            required: false,
            default: false,
            type: Boolean
        },
        isSms: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    components: {
        OtcInput
    },
    data() {
        return {
            code: ''
        };
    },
    methods: {
        onCompleteHandler(e) {
            this.$emit("setValue", e);
        },
        onChangedHandler(e) {
            this.$emit('changed')
        },
        onPasteHandler(e) {
            this.$emit("setValue", e);
            this.submit();
        },
        obscureEmail(email)  {
            if (email.includes('@') && email.includes('.')) {
                const [name, domain] = email.split("@");
                const [host, ext] = domain.split(".")
                return `${ name[0] }${ new Array(name.length).join("*") }@${ new Array(host.length).join("*") }${ host[host.length-1] }.${ ext }`
            } else {
                return 'email.'
            }
        },
        submit(){
            this.$emit("verify");
        }
            
    }
};
